import mitt from 'mitt';

export let emitter = mitt();

export default function (app) {
    app.config.globalProperties.$emitter = emitter;
}